import {
  createNgModule
} from '@angular/core';
import type {
  InjectionToken,
  Type
} from '@angular/core';
import type { Loader } from '../domain/module-loader.interface';

export abstract class ModuleDataLoaderService {

  protected async loadData<T, M>(loader: Loader, token: InjectionToken<T>): Promise<T | undefined> {
    const moduleFactory: Awaited<T> = await loader?.loadChildren<T>();
    const moduleRef = createNgModule(moduleFactory as Type<M>);
    return moduleRef.injector.get(token);
  }
}
